"use strict";

exports.__esModule = true;
exports.defaultBreakpoints = exports.createMediaQuery = void 0;
exports.parseBreakpoints = parseBreakpoints;
exports.parseResponsiveObject = parseResponsiveObject;
exports.parseResponsiveStyle = parseResponsiveStyle;
exports.responsive = responsive;

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

exports.createMediaQuery = createMediaQuery;
var defaultBreakpoints = ['600px', '1024px', '1280px', '1920px'];
exports.defaultBreakpoints = defaultBreakpoints;

function parseBreakpoints(breakpoints) {
  return breakpoints.map(function (item) {
    return createMediaQuery(item);
  });
}

function parseResponsiveStyle(options) {
  var cache = options.cache,
      propValue = options.propValue,
      props = options.props,
      scale = options.scale,
      systemConfig = options.systemConfig;
  var mediaQueries = cache.get('mediaQueries');
  var styles = {};
  propValue.slice(0, mediaQueries.length).forEach(function (item, index) {
    var _extends2;

    var media = mediaQueries[index];
    var value = typeof item === 'function' ? item(props.theme) : item;
    var style = systemConfig(value, scale, props);
    styles = !media ? _extends({}, styles, style) : _extends({}, styles, (_extends2 = {}, _extends2[media] = _extends({}, styles[media], style), _extends2));
  });
  return styles;
}

function parseResponsiveObject(options) {
  var cache = options.cache,
      propValue = options.propValue,
      props = options.props,
      scale = options.scale,
      systemConfig = options.systemConfig;
  var breakpoints = cache.get('breakpoints');
  var styles = {};

  for (var _key in propValue) {
    var breakpoint = breakpoints[_key];
    var item = propValue[_key];
    var value = typeof item === 'function' ? item(props.theme) : item;
    var style = systemConfig(value, scale, props);

    if (!breakpoint) {
      styles = _extends({}, styles, style);
    } else {
      var _extends3;

      var media = createMediaQuery(breakpoint);
      styles = _extends({}, styles, (_extends3 = {}, _extends3[media] = _extends({}, styles[media], style), _extends3));
    }
  }

  return styles;
}

function responsive(styles) {
  return function (theme) {
    var result = {};
    var breakpoints = (0, _lodash["default"])(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(parseBreakpoints(breakpoints));

    for (var style in styles) {
      var styleValue = typeof styles[style] === 'function' ? styles[style](theme) : styles[style];
      if (styleValue === null) continue;

      if (!Array.isArray(styleValue)) {
        result[style] = styleValue;
        continue;
      }

      for (var i = 0; i < styleValue.slice(0, mediaQueries.length).length; i += 1) {
        var media = mediaQueries[i];

        if (!media) {
          result[style] = styleValue[i];
          continue;
        }

        result[media] = result[media] || {};
        if (styleValue[i] == null) continue;
        result[media][style] = styleValue[i];
      }
    }

    return result;
  };
}